import React from 'react';
import { LightBackground } from 'scy/Background';
import styles from './styles.mod.scss';
import { AccentH5 } from 'scy/text';
import margin from 'scy/margin.mod.scss';

const AccountSection = ({ title, children }) => {
  return (
    <section className={styles.section}>
      <AccentH5
        uppercase
        tag="h1"
        marginClass={`${margin.top_0} ${margin.bottom_sm}`}
      >
        {title}
      </AccentH5>
      <LightBackground className={styles.card}>{children}</LightBackground>
    </section>
  );
};

export default AccountSection;
